import styled from "styled-components/macro";

import FnrButton from "UI/FnrButton3";
import { FnrPopover } from "UI/FnrPopover2";

import { usePaymentMethodState } from "./";

export default function DeleteConfirmationPopover({
  buttonRef,
  show,
  onShouldClose,
}) {
  const {
    deleting,
    deletePaymentMethod,
    isDeleted,
    hasRecurringPayment,
    paymentType,
  } = usePaymentMethodState();

  const paymentTypeToDisplay = paymentType === "bank" ? "account" : "card";

  return (
    <FnrPopover
      buttonRef={buttonRef}
      show={(show || deleting) && !isDeleted}
      onShouldClose={onShouldClose}
    >
      {hasRecurringPayment ? (
        <Wrapper>
          This {paymentTypeToDisplay} is associated with a recurring gift.
          Please update your recurring gift in order to delete this{" "}
          {paymentTypeToDisplay}.
          <ButtonsWrapper>
            <div />
            <FnrButton onClick={onShouldClose}>OK</FnrButton>
          </ButtonsWrapper>
        </Wrapper>
      ) : (
        <Wrapper>
          Are you sure you would like to delete this {paymentTypeToDisplay}?
          <ButtonsWrapper>
            <FnrButton
              onClick={deleting ? null : onShouldClose}
              disabled={deleting}
            >
              Cancel
            </FnrButton>
            <FnrButton
              color="red"
              loading={deleting}
              onClick={deletePaymentMethod}
            >
              Delete
            </FnrButton>
          </ButtonsWrapper>
        </Wrapper>
      )}
    </FnrPopover>
  );
}

const Wrapper = styled.div`
  padding: 6px 10px;
  padding-bottom: 10px;
  max-width: 240px;
`;

const ButtonsWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
`;
